export default {
  审计管理列表: "Audit Management List",
  拜访管理列表: "Visit Management List",
  添加: "Add",
  导入: "Import",
  供应商: "Supplier",
  物料: "Material",
  "请输入供应商编号/名称": "Enter supplier code/name",
  "请输入物料编号/名称": "Enter material code/name",
  拜访类型: "Visit Type",
  请选择拜访类型: "Select visit type",
  物料类别: "Material Category",
  请选择物料类别: "Select material category",
  负责人: "Responsible Person",
  请选择负责人: "Select responsible person",
  工厂: "Factory",
  请选择工厂: "Select factory",
  审计方式: "Audit Method",
  请选择审计方式: "Select audit method",
  拜访状态: "Visit Status",
  供应商阶段: "Supplier Stage",
  供应商编号: "Supplier Code",
  供应商名称: "Supplier Name",
  "供应商名称（中文）": "Supplier Name (Chinese)",
  "供应商名称（英文）": "Supplier Name (English)",
  二级物料类别: "Secondary Material Category",
  供货物料: "Supplied Materials",
  上一年度采购金额: "Last Year Purchase Amount",
  "上一年度采购金额（HKD）": "Last Year Purchase Amount (HKD)",
  拜访日期: "Visit Date",
  操作: "Action",
  审计状态: "Audit Status",
  审计需求工厂: "Audit Required Factory",
  审计日期: "Audit Date",
  待通知供应商: "Pending Supplier Notification",
  待拜访: "Pending Visit",
  拜访中: "Visiting",
  待提交拜访结果: "Pending Visit Result Submission",
  已结束: "Completed",
  待供应商提供文件: "Pending Supplier Documents",
  待审计: "Pending Audit",
  审计中: "Auditing",
  待提交审计结果: "Pending Audit Result Submission",
  巩固战略伙伴关系: "Strengthen Strategic Partnership",
  解决特定业务问题: "Resolve Specific Business Issues",
  现场评估与审核: "On-site Assessment & Audit",
  日常沟通: "Daily Communication",
  现场审计: "On-site Audit",
  纸质审计: "Paper Audit",
  远程审计: "Remote Audit",
  第三方审计: "Third-party Audit",
  查看: "View",
  编辑: "Edit",
  删除: "Delete",
  通知供应商: "Notify Supplier",
  填写拜访结果: "Fill Visit Result",
  填写审计结果: "Fill Audit Result",
  供应商拜访登记表: "Supplier Visit Registration Form",
  添加审计记录: "Add Audit Record",
  编辑拜访记录: "Edit Visit Record",
  编辑审计记录: "Edit Audit Record",
  查看拜访记录: "View Visit Record",
  查看审计记录: "View Audit Record",
  导入审计记录: "Import Audit Record",
  供应商信息: "Supplier Information",
  国家: "Country",
  "省份/城市": "Province/City",
  "街道/门牌号": "Street/Address",
  物料信息: "Material Information",
  请输入供货物料: "Enter supplied materials",
  拜访信息: "Visit Information",
  审计信息: "Audit Information",
  "拜访频次（次/年）": "Visit Frequency (times/year)",
  请输入拜访频次: "Enter visit frequency",
  开始日期: "Start Date",
  结束日期: "End Date",
  至: "To",
  请选择完整的拜访日期范围: "Please select complete visit date range",
  拜访原因: "Visit Reason",
  请输入拜访原因: "Enter visit reason",
  拜访内容: "Visit Content",
  请输入拜访内容: "Enter visit content",
  拜访准备资料: "Visit Preparation Materials",
  拜访结果: "Visit Result",
  审计结果: "Audit Result",
  拜访会议纪要: "Visit Meeting Minutes",
  请输入拜访会议纪要: "Enter visit meeting minutes",
  会议相关资料: "Meeting Related Materials",
  请选择审计需求工厂: "Select audit required factory",
  审计原因: "Audit Reason",
  请输入审计原因: "Enter audit reason",
  审计内容: "Audit Content",
  请输入审计内容: "Enter audit content",
  审计等级: "Audit Level",
  请选择审计等级: "Select audit level",
  审计结果评价: "Audit Result Evaluation",
  请输入审计结果评价: "Enter audit result evaluation",
  附件: "Attachment",
  上传文件: "Upload File",
  文件上传: "File Upload",
  点击上传: "Click to Upload",
  请先选择要导入的文件: "Please select a file to import first",
  "只能上传 Excel 文件": "Only Excel files can be uploaded",
  "文件大小不能超过 10MB": "File size cannot exceed 10MB",
  导入成功: "Import successful",
  "导入失败,请重试": "Import failed, please retry",
  模板下载成功: "Template downloaded successfully",
  "模板下载失败，请重试": "Template download failed, please retry",
  "1. 下载导入模板": "1. Download Import Template",
  下载模板: "Download Template",
  "请先下载模板,按照模板格式填写数据后再导入":
    "Please download the template first, fill in data according to the format, then import",
  "2. 上传文件": "2. Upload File",
  选择文件: "Select File",
  "支持 .xls 和 .xlsx 格式,文件大小不超过 10MB":
    "Supports .xls and .xlsx formats, file size not exceeding 10MB",
  确定导入: "Confirm Import",
  确认通知: "Confirm Notification",
  "您确定要通知供应商吗？": "Are you sure you want to notify the supplier?",
  确定: "Confirm",
  取消: "Cancel",
  通知供应商成功: "Supplier notification successful",
  "通知供应商失败，请重试": "Supplier notification failed, please retry",
  记录ID不存在: "Record ID does not exist",
  填写拜访结果成功: "Visit result filled successfully",
  填写拜访结果失败: "Failed to fill visit result",
  请先选择供应商: "Please select a supplier first",
  请选择拜访日期: "Please select visit date",
  修改并通知成功: "Modified and notified successfully",
  提交并通知成功: "Submitted and notified successfully",
  提交成功: "Submitted successfully",
  操作失败: "Operation failed",
  加载拜访记录详情失败: "Failed to load visit record details",
  获取供应商列表失败: "Failed to get supplier list",
  获取供应商详细信息失败: "Failed to get supplier details",
  修改审计记录成功: "Audit record modified successfully",
  新增审计记录成功: "Audit record added successfully",
  填写审计结果成功: "Audit result filled successfully",
  填写审计结果失败: "Failed to fill audit result",
  加载审计记录详情失败: "Failed to load audit record details",
  获取供应商信息失败: "Failed to get supplier information",
  "共 {{count}} 条数据": "Total {{count}} items",
  请输入供应商编号搜索: "Enter supplier code to search",
  优秀: "Excellent",
  良好: "Good",
  合格: "Qualified",
  不合格: "Unqualified",
  文件: "File",
};
